import { toast } from "react-toastify";
import { deleteItems, updateStateData } from "../Store/actions";
import store from "../Store/store";
import { sendApiRequest } from "./requestConfig";

// Same shape as the store notes (stores/{id}/notes). The /notes endpoint is not live in the backend yet.
const campaignNotesPath = (campaignId) => "campaigns/" + campaignId + "/notes";

export const fetchCampaignInternalNote = async (campaignId) => {
  // A campaign without a note answers 200 with an empty body. The default request runs response.json() and throws on it,
  // silent parses an empty body as null instead. The loader is handled by the caller (batch loading).
  const fetchNote = await sendApiRequest(campaignNotesPath(campaignId), {}, "GET", { silent: true });
  //evaluate api response
  if (typeof fetchNote.success !== "undefined" && fetchNote.success === true) {
    // no note yet: the modal opens with an empty editor
    if (fetchNote.response !== null && typeof fetchNote.response.notes !== "undefined") {
      store.dispatch(
        updateStateData({
          campaign_internal_note: fetchNote.response.notes,
          campaign_internal_note_id: fetchNote.response.id,
        })
      );
    }

    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

// noteText may be empty: internal notes can be cleared
export const saveCampaignInternalNote = async (noteText, campaignId, noteId) => {
  let notesRequestBody = { notes: noteText };
  if (noteId !== "") {
    notesRequestBody = {
      ...notesRequestBody,
      id: noteId,
    };
  }
  const saveNote = await sendApiRequest(campaignNotesPath(campaignId) + "/save", notesRequestBody, "POST");
  //evaluate api response
  if (typeof saveNote.success !== "undefined" && saveNote.success === true) {
    toast("Note saved successfully", { type: "success" });
    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

// reset internal note params in redux
export const resetCampaignInternalNote = () => {
  store.dispatch(deleteItems(["campaign_internal_note", "campaign_internal_note_id"]));
};
